import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposFormacoes } from './tipos_formacoes_service';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var COLUNAS = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 500,
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
export var TiposFormacoesListar = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_FORMACOES, paginaPermissao: FUNCIONALIDADES.TIPOS_FORMACOES, rota: ROUTES.TIPOS_FORMACOES, columns: COLUNAS, filtrosIniciais: {
            situacao: '-1',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            return getTiposFormacoes(textoBusca === '' ? null : textoBusca, filtros.situacao === '-1' ? null : filtros.situacao, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizarFiltros({ situacao: novaSituacao });
            } })); } }));
};
export default TiposFormacoesListar;
